<template>
  <div>
    <o-table :title="$t('offer.orders')" url="/api/cart-orders?include=user,wholesaler" :per-page="perPageSize" ref="tableList" :enable-new="false" :enable-delete="false" default-sort-by-direction="desc">
      <template slot="filter">
        <div class="d-flex w-100">
          <div>
            <o-filter v-on:filter-updated="onFilterUpdated">
                <o-filter-select value-field="id" text-field="name" :items="users" :title="$t('offer.user')" column="user_id"></o-filter-select>
                <o-filter-select value-field="id" text-field="wholesaler" :items="wholesalers" :title="$t('offer.wholesaler')" column="wholesaler_id"></o-filter-select>
                <o-filter-select value-field="value" text-field="text" :items="years" title="Year" column="year"></o-filter-select>
                <o-filter-datepicker :title="$t('offer.date')" column="created_at"></o-filter-datepicker>
            </o-filter>
          </div>
          <div class="ml-auto pt-4 d-flex align-items-center">
            <span class="mr-2" style="white-space:nowrap;font-size:0.875rem;">Show:</span>
            <b-form-select v-model="perPageSize" :options="[20, 50, 100, 200, 500]" class="mr-3" style="width: 80px;" size="sm"></b-form-select>
            
            <b-button v-if="selectedIds.length > 0" variant="primary" :disabled="downloadingPdf" @click="downloadBulkPdf" size="sm">
              <span v-if="downloadingPdf">
                <fa icon="spinner" spin /> Generating PDFs...
              </span>
              <span v-else>
                <fa icon="file-pdf" /> PDF ({{ selectedIds.length }})
              </span>
            </b-button>
          </div>
        </div>
      </template> 
      <template slot="head">
        <th style="width: 40px">
          <input type="checkbox" v-model="selectAll" @change="toggleSelectAll" />
        </th>
        <o-table-header column="id">{{$t('offer.id')}}</o-table-header>
        <o-table-header column="name">{{$t('offer.name')}}</o-table-header>
        <o-table-header column="user">{{$t('offer.user')}}</o-table-header>
        <o-table-header column="wholesaler">{{$t('offer.wholesaler')}}</o-table-header>
        <o-table-header column="order_total" class="text-right">{{$t('offer.order_total')}}</o-table-header>
        <o-table-header column="created_at">{{$t('offer.created_at')}}</o-table-header>
      </template>
      <template slot="body" slot-scope="props">
        <td @click.stop>
          <input type="checkbox" :value="props.item.id" v-model="selectedIds" />
        </td>
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.user ? props.item.user.data.name : '' }}</td>
        <td>{{ props.item.wholesaler && props.item.wholesaler.data ? props.item.wholesaler.data.wholesaler : '' }}</td>
        <td class="text-right">{{ props.item.order_total }}</td>
        <td>{{ props.item.created_at | formatDate }}</td>
      </template>
    </o-table>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import axios from "axios"

export default {
  data() {
    return {
      users: [],
      wholesalers: [],
      years: [],
      selectedIds: [],
      selectAll: false,
      downloadingPdf: false,
      perPageSize: 20
    }
  },
  methods: {
    loadSalesRepUsers() {
      axios.get('/api/cart-orders/users').then((response) => {
        this.users = response.data
      })
    },
    loadWholesalers() {
      axios.get('/api/cart-wholesalers', {params: {per_page: 999}}).then((response) => {
        this.wholesalers = response.data.data
      })
    },
    buildYears() {
      const currentYear = new Date().getFullYear()
      const years = []
      for (let y = currentYear; y >= 2020; y--) {
        years.push({value: y, text: y.toString()})
      }
      this.years = years
    },
    onFilterUpdated(filters) {
      this.selectedIds = []
      this.selectAll = false
      this.$refs.tableList.setFilters(filters)
    },
    toggleSelectAll() {
      if (this.selectAll) {
        const items = this.$refs.tableList.data.data || []
        this.selectedIds = items.map(item => item.id)
      } else {
        this.selectedIds = []
      }
    },
    downloadBulkPdf() {
      this.downloadingPdf = true
      axios.post('/api/cart-orders/bulk-pdf', {ids: this.selectedIds}, {responseType: 'arraybuffer'})
        .then(response => {
          require('downloadjs')(response.data, 'orders.zip', 'application/zip')
          this.downloadingPdf = false
        })
        .catch(() => {
          this.downloadingPdf = false
          window.alert('Could not generate PDFs')
        })
    }
  },
  mounted() {
    this.loadSalesRepUsers()
    this.loadWholesalers()
    this.buildYears()
  },
  computed: mapGetters({
    locale: 'lang/locale',
    user: 'auth/user'
  }),
}
</script>